import React from "react";
import { useFormContext } from "react-hook-form";

const FormError: React.FC = (): React.ReactElement => {
  const {
    formState: { errors },
  } = useFormContext();

  if (!errors.root) {
    return <div />;
  }

  return (
    errors.root && (
      <div className="mt-1 text-base text-error">{errors.root.message}</div>
    )
  );
};

export default FormError;
